import styled from '@emotion/styled';
import { SafetyOutlined } from '@ant-design/icons';

export const Label = styled.p`
  margin-bottom: ${props => props.theme.spacing.xxs};
`;

export const DescriptionForLabel = styled.p`
  font-weight: ${props => props.theme.fontWeight.light};
  font-style: italic;
  margin-bottom: ${props => props.theme.spacing.xxs};
`;

export const FinancialValueText = styled.div`
  text-align: right;
  margin-right: ${props => props.theme.spacing.md};
`;

export const ExtraInfoText = styled.span`
  font-style: italic;
  font-weight: ${props => props.theme.fontWeight.light};
`;

export const SummaryValueText = styled.p`
  font-size: 32px;
  font-weight: ${props => props.theme.fontWeight.bold};
  margin-bottom: 0;
`;

export const SecureIcon = styled(SafetyOutlined)`
  color: ${props => (props.hasMedicalCard ? props.theme.color.green : props.theme.color.red)};
  margin-right: ${props => props.theme.spacing.xxs};
`;
